"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const threshold = 1000000;
const Suffix = _styledComponents.default.span`
	font-size: 70%;
`;

const customRounder = value => {
  const stringValue = value.toString();
  const [number, decimal] = stringValue.split('.');
  return !decimal ? number : `${number}.${decimal.slice(0, 1)}`;
};

const AbbreviatedNumber = ({
  value,
  suffixProps,
  ...props
}) => {
  if (value >= threshold) {
    return /*#__PURE__*/_react.default.createElement("span", _extends({
      title: value.toLocaleString()
    }, props), customRounder(value / threshold), /*#__PURE__*/_react.default.createElement(Suffix, suffixProps, " Million"));
  }

  return /*#__PURE__*/_react.default.createElement("span", props, value.toLocaleString());
};

AbbreviatedNumber.propTypes = {
  value: _propTypes.default.number.isRequired,
  suffixProps: _propTypes.default.shape()
};
AbbreviatedNumber.defaultProps = {
  suffixProps: null
};
var _default = AbbreviatedNumber;
exports.default = _default;